import styles from './CardEstabelecimento.module.css';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight, FaClock } from 'react-icons/fa';


function CardEstabelecimento({ estabelecimento }) {
  const navigate = useNavigate();

  const estaFechado = () => {
    // Se fechamento_manual está ativo, o estabelecimento está fechado manualmente
    if (estabelecimento.fechamento_manual) {
      return true;
    }

    // Caso contrário, verifica pelo horário de funcionamento
    if (estabelecimento.hora_abertura && estabelecimento.hora_fechamento) {
      const agora = new Date();
      const horaAtual = agora.getHours().toString().padStart(2, '0') + ':' +
        agora.getMinutes().toString().padStart(2, '0');

      if (horaAtual < estabelecimento.hora_abertura.substring(0, 5) ||
          horaAtual >= estabelecimento.hora_fechamento.substring(0, 5)) {
        return true;
      }
    }

    return false;
  };

  const fechado = estaFechado();

  return (
    <div
      className={`${styles.cardEstabelecimento} ${fechado ? styles.cardFechado : ''}`}
      onClick={() => navigate(`/estabelecimento/${estabelecimento.id_estabelecimento}`)}
    >
      {/* Imagem do Estabelecimento */}
      <div className={styles.imagemContainer}>
        {estabelecimento.logo ? (
          <img
            src={`${process.env.REACT_APP_API_URL || 'http://localhost:3002'}${estabelecimento.logo}`}
            alt={estabelecimento.nomeEstabelecimento}
            className={styles.logo}
          />
        ) : (
          <div className={styles.logoFallback}>
            {estabelecimento.nomeEstabelecimento?.charAt(0).toUpperCase()}
          </div>
        )}
        {fechado && <div className={styles.overlayFechado} />}
      </div>

      {/* Informações do Estabelecimento */}
      <div className={styles.info}>
        <div className={styles.topRow}>
          <h3 className={styles.nome}>{estabelecimento.nomeEstabelecimento}</h3>
          <span className={fechado ? styles.badgeFechado : styles.badgeAberto}>
            {fechado ? 'Fechado' : 'Aberto'}
          </span>
        </div>

        {estabelecimento.hora_abertura && estabelecimento.hora_fechamento && (
          <p className={styles.horario}>
            <FaClock className={styles.clockIcon} />
            {estabelecimento.hora_abertura.substring(0, 5)} – {estabelecimento.hora_fechamento.substring(0, 5)}
          </p>
        )}

        <div className={styles.tags}>
          {estabelecimento.entrega_gratis && (
            <span className={styles.tagEntregaGratis}>Entrega grátis</span>
          )}
          {estabelecimento.promocao && (
            <span className={styles.tagPromocao}>Promoção</span>
          )}
        </div>
      </div>

      {/* Seta de navegação */}
      <FaChevronRight className={styles.chevron} />
    </div>
  );
}

export default CardEstabelecimento;
